// extracted by mini-css-extract-plugin
module.exports = {"calendarContentHolder":"CalendarSidebar_calendarContentHolder__YzSM-","calendarContentHolderNonPresenter":"CalendarSidebar_calendarContentHolderNonPresenter__fPwfI"};